export enum HorseLimbEnum {
  FORE = 'fore',
  HIND = 'hind',
}

export enum HorseBodyPartEnum {
  HEAD = 'head',
  HIND = 'hind',
  WITHERS = 'withers',
  EARS = 'ears',
}

export enum HorseLimbSideEnum {
  RIGHT = 'right',
  LEFT = 'left',
}

export enum HorseLimbLabelsEN {
  RF = 'RF',
  LF = 'LF',
  RH = 'RH',
  LH = 'LH',
}

export enum HorseLimbLabelsSV {
  HF = 'HF',
  VF = 'VF',
  HH = 'HH',
  VH = 'VH',
}

export enum AsymmetryLimbEnum {
  LEFT_FORE_LIMB = 'leftForelimb',
  RIGHT_FORE_LIMB = 'rightForelimb',
  LEFT_HIND_LIMB = 'leftHindlimb',
  RIGHT_HIND_LIMB = 'rightHindlimb',
}

export enum AsymmetryLimbLabelEnum {
  leftForelimb = 'LF',
  rightForelimb = 'RF',
  leftHindlimb = 'LH',
  rightHindlimb = 'RH',
}

export enum HorseBodyPartWeightsEnum {
  head = 10,
  hind = 0,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  WITHERS = 0,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  EARS = 0,
}
